import { defineStore } from "pinia";
import services from "./services";
import { ElLoading, ElNotification, UploadUserFile } from "element-plus";
// import { Proyecto } from "./ProyectosStore";
import { User } from "./UserStore";
export enum Roles {
  Admin = "Admin",
  Manager = "Manager",
  User = "User",
  EditarListaMateriales = "EditarListaMateriales",
}
export interface Sort {
  prop: string;
  order: string;
}

export interface Option {
  value: number;
  label: string;
}

export interface ValidateData {
  [key: string]: boolean;
}
export interface ValidateDataItem {
  idPA: number;
  ValidateData: ValidateData;
}
export interface Configuracion {
  Key: string;
  Valor: string;
}
export interface Jerarquia {
  NODE_LIST: NODE_LIST;
}
export interface NODE_LIST {
  BAPIMAT_PRODH: BAPIMAT_PRODH[];
}
export interface BAPIMAT_PRODH {
  BROTHER_PROD_HIER: string;
  LANGU: string;
  LANGU_ISO: string;
  NODE_LEVEL: string;
  NODE_TEXT: string;
  PARENT_PROD_HIER: string;
  PROD_HIER: string;
  TEXT: string;
}
export interface Equipo {
  Nombre: string;
  SubEquipos: SubEquipo[];
  Key: string;
}
export interface EmailObj {
  Para: User[];
  Subject: string;
  Body: string;
}
export interface EmailObjExtended extends EmailObj {
  TemplateName: string;
  Descripcion: string;
}
export interface SubEquipo {
  Nombre: string;
  Key: string;
}
export interface PuntesProject {
  Flujo: string;
  ProjectTemplateName: string;
  Id: string;
}
export interface UploadUserFileExtended extends UploadUserFile {
  downloadUrl: string;
  siteId: string;
  itemId: string;
}
export interface AppRole {
  id: string;
  displayName: string;
  value: string;
}

export const useCommonStore = defineStore("CommonStore", {
  // convert to a function
  state: () => ({
    Familias: [] as BAPIMAT_PRODH[] | undefined,
    Subfamilias: [] as BAPIMAT_PRODH[] | undefined,
    Marcas: [] as string[] | undefined,
    Formatos: [] as BAPIMAT_PRODH[] | undefined,
    TiposProductos: [] as string[] | undefined,
    CanalesVentas: [] as string[] | undefined,
    TiposVentas: [] as string[] | undefined,
    CodigosBarrasNuevos: [] as string[] | undefined,
    ForoAprobacionPA: [] as string[] | undefined,
    CategoriasMaterial: [] as string[] | undefined,
    Acabados: [] as string[] | undefined,
    Jerarquia: {} as Jerarquia | undefined,
    Equipos: [] as Equipo[],
    AppRoles: [] as AppRole[],
    Agencias: [] as string[] | undefined,
    TooltipPA: [] as string[] | undefined,
    TooltipMaterial: [] as string[] | undefined,
    EmailMateriales: {} as EmailObj,
    EmailInicioTareasAsignadas: {} as EmailObj,
    EmailTareasAsignadas: {} as EmailObj,
    EmailTareasAsignadasNuevosItems: {} as EmailObj,
    TareasCambioCodigoMaterial: {} as EmailObj,
    PuntesProjectTemplates: [] as PuntesProject[],
    Unidades: [] as string[] | undefined,
    Divisiones: [] as string[] | undefined,
    TipoLanzamiento: [] as string[] | undefined,
    Centros: [] as string[],
    PlantillasEmailsTareasCompletadas: [] as EmailObjExtended[],
  }),
  actions: {
    async GetDatosMaestros() {
      await services.ConfiguracionService.getAll().then(
        (result: { data: Configuracion[] }) => {
          result.data.forEach((config) => {
            this.GuardarDatosStore(config);
            this.Centros = ["1110", "1120"];
          });
        }
      );

      await services.SAPService.getHierarchy()
        .then((result: { data: Jerarquia }) => {
          this.Jerarquia = result.data;
        })
        .catch((error: Error) => {
          console.log(
            "Error al obtener la jerarquia de productos de SAP:",
            error
          );
        });

      this.Familias =
        this.Jerarquia &&
        this.Jerarquia.NODE_LIST.BAPIMAT_PRODH.filter(
          (item) => item.NODE_LEVEL === "1"
        );
      this.Subfamilias =
        this.Jerarquia &&
        this.Jerarquia.NODE_LIST.BAPIMAT_PRODH.filter(
          (item) => item.NODE_LEVEL === "2"
        );

      this.Formatos =
        this.Jerarquia &&
        this.Jerarquia.NODE_LIST.BAPIMAT_PRODH.filter(
          (item) => item.NODE_LEVEL === "3"
        );
    },
    GuardarDatosStore(config: Configuracion) {
      switch (config.Key) {
        case "Acabados":
          this.Acabados = JSON.parse(config.Valor);
          break;
        case "ForoAprobacionPA":
          this.ForoAprobacionPA = JSON.parse(config.Valor);
          break;
        case "CodigosBarrasNuevos":
          this.CodigosBarrasNuevos = JSON.parse(config.Valor);
          break;
        case "TiposVentas":
          this.TiposVentas = JSON.parse(config.Valor);
          break;
        case "CanalesVentas":
          this.CanalesVentas = JSON.parse(config.Valor);
          break;
        case "TiposProductos":
          this.TiposProductos = JSON.parse(config.Valor);
          break;
        case "Equipos":
          this.Equipos = JSON.parse(config.Valor);
          break;
        case "CategoriasMaterial":
          this.CategoriasMaterial = JSON.parse(config.Valor);
          break;
        case "Agencias":
          this.Agencias = JSON.parse(config.Valor);
          break;
        case "Marcas":
          this.Marcas = JSON.parse(config.Valor);
          break;
        case "TooltipPA":
          this.TooltipPA = JSON.parse(config.Valor);
          break;
        case "TooltipMaterial":
          this.TooltipMaterial = JSON.parse(config.Valor);
          break;
        case "EmailMateriales":
          this.EmailMateriales = JSON.parse(config.Valor);
          //JSON.parse(
          //  config.Valor.replaceAll(/[\n\r\t]/g, "") // Elimina saltos de línea, retornos de carro y tabulaciones
             // .replaceAll(/\\"/g, '"') // Reemplaza comillas dobles escapadas
             // .replaceAll(/\\'/g, "'")
          //); // Reemplaza comillas simples escapadas 
          break;
        case "InicioTareasAsignadas":
          this.EmailInicioTareasAsignadas = JSON.parse(config.Valor);
          /*JSON.parse(
            config.Valor.replace(/[\n\r\t]/g, "") // Elimina saltos de línea, retornos de carro y tabulaciones
              .replace(/\\"/g, '"') // Reemplaza comillas dobles escapadas
              .replace(/\\'/g, "'")
          ); // Reemplaza comillas simples escapadas */
          break;
        case "TareasAsignadas":
          this.EmailTareasAsignadas = JSON.parse(config.Valor);
          /*JSON.parse(
            config.Valor.replace(/[\n\r\t]/g, "") // Elimina saltos de línea, retornos de carro y tabulaciones
              .replace(/\\"/g, '"') // Reemplaza comillas dobles escapadas
              .replace(/\\'/g, "'")
          ); // Reemplaza comillas simples escapadas */
          break;
        case "TareasAsignadasNuevosItems":
          this.EmailTareasAsignadasNuevosItems = JSON.parse(config.Valor);
          /*JSON.parse(
            config.Valor.replace(/[\n\r\t]/g, "") // Elimina saltos de línea, retornos de carro y tabulaciones
              .replace(/\\"/g, '"') // Reemplaza comillas dobles escapadas
              .replace(/\\'/g, "'")
          ); // Reemplaza comillas simples escapadas */
          break;
        case "TareasCambioCodigoMaterial":
          this.TareasCambioCodigoMaterial = JSON.parse(config.Valor);
          /* JSON.parse(
            config.Valor.replace(/[\n\r\t]/g, "") // Elimina saltos de línea, retornos de carro y tabulaciones
              .replace(/\\"/g, '"') // Reemplaza comillas dobles escapadas
              .replace(/\\'/g, "'")
          ); // Reemplaza comillas simples escapadas*/
          break;
        case "PuntesProjectTemplates":
          this.PuntesProjectTemplates = JSON.parse(config.Valor);
          break;
        case "Unidades":
          this.Unidades = JSON.parse(config.Valor);
          break;
        case "Divisiones":
          this.Divisiones = JSON.parse(config.Valor);
          break;
        case "TipoLanzamiento":
          this.TipoLanzamiento = JSON.parse(config.Valor);
          break;
        case "PlantillasEmailsTareasCompletadas":
          this.PlantillasEmailsTareasCompletadas = JSON.parse(config.Valor);
          break;
        default:
          break;
      }
    },

    GuardarDatosMaestros(
      key: string,
      values: string[] | Equipo[] | EmailObj | PuntesProject[] | undefined | EmailObjExtended[]
    ) {
      const ElLoadingInstance = ElLoading.service({ fullscreen: true });
      const dataConfig: Configuracion = {
        Key: key,
        Valor: JSON.stringify(values),
      };
      services.ConfiguracionService.update(dataConfig)
        .then(() => {
          this.GuardarDatosStore(dataConfig);
          ElLoadingInstance.close();
          ElNotification.success({
            showClose: true,
            message: "Se ha guardado correctamente " + key,
          });
        })
        .catch(() => {
          ElLoadingInstance.close();
          ElNotification.error({
            showClose: true,
            message: "Se ha producido un error al guardar " + key,
          });
        });
    },
  },
});
